<template>
    <div class="job-offers__pagination-container">
        <a
            href="#"
            class="job-offers__pagination-button"
            v-show="button_index != 0"
            v-on:click.prevent="movePages('prev')"
        >
            <!-- {!! svg('svg/we-build/left.svg') !!} -->
            <img
                class="job-offers__pagination-button--previous"
                src="/svg/we-build/right.svg"
                alt="Move paginator to see previous pages"
            />
        </a>
        <ul class="job-offers__pagination">
            <li
                v-for="(page, index) in pages"
                :key="index"
                v-on:click="pageChanger(page)"
                class="job-offers__pagination-page"
                :class="{
                    'job-offers__pagination-page--active': selected_page == page
                }"
            >
                {{
                    page.toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })
                }}
            </li>
            <li v-show="!isMaxPage">...</li>
            <li
                v-show="!isMaxPage"
                class="job-offers__pagination-page"
                :class="{
                    'job-offers__pagination-page--active':
                        selected_page == lastPageNumber
                }"
                v-on:click="switchToLastPage"
            >
                {{ lastPageNumber }}
            </li>
        </ul>
        <a
            href="#"
            class="job-offers__pagination-button"
            v-show="!isMaxPage"
            v-on:click.prevent="movePages('next')"
        >
            <img
                src="/svg/we-build/right.svg"
                alt="Move paginator to see next pages"
            />
        </a>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { paginate } from "../../helpers/helpers";

export default {
    data() {
        return {
            all_pages_of_current_jobs: [],
            DEFAULT_BUTTON_PAGE_SIZE: 3,
            pagination_page_index: 1,
            button_index: 0,
            selected_page: 0,
            index: 1,

            pages: []
        };
    },
    mounted() {
        this.generatePageButtons();
    },
    watch: {
        filtered_jobs: function() {
            this.generatePageButtons();
        },
        current_page: function() {
            this.selected_page = this.current_page;
        }
    },
    methods: {
        ...mapMutations(["move_page"]),
        generatePageButtons(index = 1) {
            let splits = [];
            this.pages = [];
            this.button_index = 0;
            this.index = 1;
            this.pagination_page_index = 1;
            this.selected_page = 1;
            //Rozdelí všetky itemy na stránky po 6 itemov (splits) aby sme
            //následne mohli určiť množstvo týchto stránok
            for (let i = 0; i < this.filtered_jobs.length; i++) {
                //Aby sa nestalo, že ked bude iba jeden item, ukaže sa 0 stránok
                if (this.jobs.length == 1) {
                    splits.push(this.filtered_jobs);
                } else {
                    splits.push(this.filtered_jobs.slice((i - 1) * 6, i * 6));
                }
            }
            splits = splits.filter(item => item.length > 0);

            splits.forEach((item, index) => {
                this.pages.push(index + 1);
            });
            this.all_pages_of_current_jobs = this.pages;
            splits.length <= 3
                ? (this.DEFAULT_BUTTON_PAGE_SIZE = splits.length)
                : (this.DEFAULT_BUTTON_PAGE_SIZE = 3);

            this.pages = paginate(
                this.pages,
                this.DEFAULT_BUTTON_PAGE_SIZE,
                index
            );
        },
        switchToLastPage() {
            this.move_page(this.lastPageNumber);

            this.movePagesToLast();
        },
        movePagesToLast() {
            //What is the last page ?
            this.pagination_page_index = this.lastPage;
            this.pages = paginate(
                this.all_pages_of_current_jobs,
                this.DEFAULT_BUTTON_PAGE_SIZE,
                this.pagination_page_index
            );
            this.button_index = this.all_pages_of_current_jobs.indexOf(
                this.lastPageNumber
            );
            this.index = this.pages.indexOf(this.lastPageNumber) + 1;
        },
        movePages(direction) {
            if (direction == "next") {
                this.move_page(this.nextPage);
                this.index++;
                this.button_index++;
                if (this.paginationLength == 0 || this.index != 4) return; //
                this.index = 1;
                this.pagination_page_index++;
            } else {
                this.move_page(this.previousPage);
                this.button_index--;
                if (this.button_index - 1 < 0) {
                    this.button_index = 0;
                }
                this.index--;
                if (this.index == 0 && this.button_index != 0) {
                    this.index = 3;
                    this.pagination_page_index--;
                }
            }

            this.pages = paginate(
                this.all_pages_of_current_jobs,
                this.DEFAULT_BUTTON_PAGE_SIZE,
                this.pagination_page_index
            );
        },
        pageChanger(page) {
            this.button_index = this.all_pages_of_current_jobs.indexOf(page);
            this.index = this.pages.indexOf(page) + 1;
            this.move_page(page);
        }
    },
    computed: {
        ...mapGetters([
            "paginated_jobs",
            "filtered_jobs"
            // ...
        ]),
        ...mapState(["current_page", "jobs"]),
        isMaxPage: function() {
            return (
                paginate(
                    this.all_pages_of_current_jobs,
                    this.DEFAULT_BUTTON_PAGE_SIZE,
                    this.pagination_page_index + 1
                ).length == 0
            );
        },
        lastPage: function() {
            return Math.ceil(
                this.all_pages_of_current_jobs.length /
                    this.DEFAULT_BUTTON_PAGE_SIZE
            );
        },
        lastPageNumber: function() {
            return this.all_pages_of_current_jobs[
                this.all_pages_of_current_jobs.length - 1
            ];
        },
        paginationLength: function() {
            return paginate(
                this.all_pages_of_current_jobs,
                this.DEFAULT_BUTTON_PAGE_SIZE,
                this.pagination_page_index + 1
            ).length;
        },
        nextPage: function() {
            return this.selected_page + 1;
        },
        previousPage: function() {
            return this.selected_page - 1;
        }
    }
};
</script>

<style></style>
